var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{staticClass:"header-container",attrs:{"height":"60px"}},[_c('h1',[_vm._v("元气管理系统")]),_c('div',{staticClass:"header-right"},[_c('el-button',{attrs:{"type":"danger","size":"small","icon":"el-icon-switch-button"},on:{"click":function($event){return _vm.$emit('logout')}}},[_vm._v(" 退出登录 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }